import { InMemoryDbService } from 'angular-in-memory-web-api';
import { accountSettingsFakeData } from '@fake-db/account-settings.data';
import { CalendarFakeData } from '@fake-db/calendar.data';
import { CardAnalyticsData } from '@fake-db/card-analytics.data';
import { CardStatisticsData } from '@fake-db/card-statistics.data';
import { DashboardFakeData } from '@fake-db/dashboard.data';
import { FAQFakeData } from '@fake-db/faq.data';
import { KBFakeData } from '@fake-db/knowledge-base.data';




export class FakeDbService implements InMemoryDbService {
  createDb(): any {
    return {
      // Data-table
   
      // Account Settings
      'account-settings-data': accountSettingsFakeData.data,

      // Knowledge Base
      'knowledge-base-data': KBFakeData.data,

      // Faq
      'faq-data': FAQFakeData.data,

   

      // Card Statistics
      'card-statistics-data': CardStatisticsData.data,

      // Card Analytics
      'card-analytics-data': CardAnalyticsData.data,

 

      // Calendar
      'calendar-events': CalendarFakeData.events,
      'calendar-filter': CalendarFakeData.calendar,

 
      // Dashboard
      'dashboard-data': DashboardFakeData.data
    };
  }
}
